/* MedVital v5 – beteenden från godkänd mockup (mockup/site/app.js + sidskript).
   Köp (ägarbeslut 2026-10-10): webbshoppen tar bara första leveransen. Abonnemang = dold
   "månad 1"-variant (<handle>-faktura-manad-1, 199 kr) via /cart/add.js UTAN selling_plan, med
   radegenskaper som Viskan läser (_Prenumeration, _Intervall, _Fortsättningspris, _Paket, Produkt).
   Leverans 2 och framåt faktureras av Viskan. Engångsköp = huvudprodukten utan egenskaper.
   Ingen egen spårningskod: Shopifys web pixels fångar cart/add och checkout automatiskt. */
(function () {
  'use strict';
  var CFG = window.MV5 || { tiers: { 1: 0, 2: 0.1, 3: 0.15 }, bundles: false, phone: '031-78 131 55' };
  var MAX = 3;

  function kr(cents) {
    var n = Math.round(cents / 100);
    return n.toLocaleString('sv-SE') + ' kr';
  }
  // Rabattsats efter totalt antal artiklar: 2 → tier 2, 3 eller fler → tier 3 (samma som Shopifys automatiska rabatt).
  // qpreview: temaeditorns förhandsvisning av 3-månaderskortet räknar med rabatten även när paketpriser är av.
  function tier(n) { return CFG.bundles || CFG.qpreview ? (CFG.tiers[Math.min(n, 3)] || 0) : 0; }
  function sum(list, f) { return list.reduce(function (s, x) { return s + x[f]; }, 0); }
  // Fortsättningspris per förpackning i hela kronor (som text), t.ex. "399".
  function contPrice(p) { return p.price % 100 === 0 ? String(p.price / 100) : (p.price / 100).toFixed(2).replace('.', ','); }
  // Varukorgsrader för ett abonnemang via faktura. entries = [{ p: produktdata, n: antal }], days = 30 eller 90.
  // _Paket = antal förpackningar i hela leveransen (styr paketrabatten på Viskans fakturor).
  // Samma format som snippets/mv5-subitems.liquid.
  function subItems(entries, days) {
    var ok = entries.filter(function (e) { return e.n > 0 && e.p.sub && e.p.start; });
    var total = ok.reduce(function (s, e) { return s + e.n; }, 0);
    return ok.map(function (e) {
      return { id: e.p.start, quantity: e.n, properties: {
        'Produkt': e.p.name, '_Prenumeration': 'ja', '_Intervall': days + ' dagar',
        '_Fortsättningspris': contPrice(e.p), '_Paket': String(total)
      } };
    });
  }
  function firstPrice(list) { return Math.round(sum(list, 'intro') * (1 - tier(list.length)) / 100) * 100; }
  // Därefter-pris (Viskan, ägarbeslut 2026-10-11): en mall per produkt och rabattnivå, priset avrundas PER PRODUKT
  // till hela kronor och summeras (Flex+ + Woman+ = 359 + 404 = 763 kr), inte round(summa × faktor).
  function unitPrice(p, n) { return Math.round(p.price * (1 - tier(n)) / 100) * 100; }
  function monthly(list) { return list.reduce(function (s, x) { return s + unitPrice(x, list.length); }, 0); }
  function perDay(cents, n) { return (cents / 100 / n / 30).toFixed(1).replace('.', ','); }
  function pop(el) { if (!el) return; el.classList.remove('pop'); void el.offsetWidth; el.classList.add('pop'); }
  function readData(root) {
    var s = root && root.querySelector('script[data-mv5-data]');
    try { return s ? JSON.parse(s.textContent) : null; } catch (e) { return null; }
  }
  // Besparingsruta: ordinarie pris överstruket + gul pill + "Du sparar X kr". Visas bara med riktig paketrabatt.
  // full/now i öre, n = antal artiklar, per = text efter beloppet ("varje leverans" / "var 90:e dag").
  function renderSave(root, full, now, n, per, animate) {
    var t = tier(n), show = n > 1 && t > 0 && full > now;
    var fullEl = root.querySelector('[data-p-full]'), box = root.querySelector('[data-p-save]');
    if (fullEl) {
      fullEl.hidden = !show;
      var sr = fullEl.querySelector('.vh');
      fullEl.textContent = '';
      if (sr) fullEl.appendChild(sr);
      fullEl.appendChild(document.createTextNode(kr(full)));
    }
    if (box) {
      box.hidden = !show;
      var pct = box.querySelector('[data-p-pct]'), amt = box.querySelector('[data-p-save-amt]'), p = box.querySelector('[data-p-save-per]');
      if (pct) pct.textContent = 'Spara ' + Math.round(t * 100) + ' %';
      if (amt) amt.textContent = kr(full - now);
      if (p && per) p.textContent = per;
      if (show && animate) pop(box);
    }
  }

  /* ---------- Köp → kassan ---------- */
  function showErr(btn, msg) {
    var scope = btn.closest('[data-mv5-buybox],[data-mv5-builder],.hero-cta,.mid-cta,.offer') || btn.parentNode;
    var e = scope.querySelector('[data-mv5-err]');
    if (e) { e.textContent = msg; e.hidden = false; }
  }
  // Varukorgsknappen i headern: antalet uppdateras efter köpknapparna och när sidan återställs ur bakåt-cachen (t.ex. tillbaka från kassan).
  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = String(n); });
    document.querySelectorAll('[data-mv5-cart]').forEach(function (a) {
      var label = a.querySelector('.cart-l');
      a.setAttribute('aria-label', (label ? label.textContent.trim() : 'Varukorg') + ', ' + n + (n === 1 ? ' vara' : ' varor'));
    });
  }
  function syncCart() {
    if (!document.querySelector('[data-cart-count]')) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c && typeof c.item_count === 'number') setCartCount(c.item_count); })
      .catch(function () {});
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) syncCart(); });
  function checkout(items, btn) {
    if (!items || !items.length || (btn && btn.getAttribute('aria-busy') === 'true')) return;
    if (btn) btn.setAttribute('aria-busy', 'true');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    // Tömmer först varukorgen så att kassan visar exakt det som valts (skyddar mot dubbla klick/bakåtknapp).
    fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } })
      .then(function () {
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error((j && (j.description || j.message)) || 'fel'); });
        setCartCount(items.reduce(function (s, i) { return s + (i.quantity || 1); }, 0));
        window.location.href = root + 'checkout';
      })
      .catch(function () {
        if (btn) btn.removeAttribute('aria-busy');
        if (btn) showErr(btn, 'Något gick fel. Försök igen eller ring oss på ' + CFG.phone + '.');
      });
  }
  window.MV5checkout = checkout;

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mv5-items]');
    if (!b) return;
    e.preventDefault();
    try { checkout(JSON.parse(b.getAttribute('data-mv5-items')), b); } catch (err) { /* ogiltig data */ }
  });

  /* ---------- Galleri ---------- */
  function initGallery(gal) {
    var track = gal.querySelector('.gal-track');
    var wrap = gal.closest('.gal-wrap') || gal.parentNode;
    var slides = track.querySelectorAll('.slide');
    var cur = 0;
    // Bilder efter den första laddas först efter sidladdning eller interaktion (skyddar LCP på mobil).
    var hydrated = false;
    function hydrate() {
      if (hydrated) return; hydrated = true;
      wrap.querySelectorAll('img[data-src]').forEach(function (im) {
        if (im.dataset.srcset) im.srcset = im.dataset.srcset;
        im.src = im.dataset.src;
        im.removeAttribute('data-src'); im.removeAttribute('data-srcset');
      });
    }
    if (document.readyState === 'complete') setTimeout(hydrate, 300);
    else window.addEventListener('load', function () { setTimeout(hydrate, 300); }, { once: true });
    ['pointerdown', 'touchstart', 'keydown', 'mouseenter'].forEach(function (ev) { wrap.addEventListener(ev, hydrate, { once: true, passive: true }); });
    function setCur(i) {
      cur = Math.max(0, Math.min(slides.length - 1, i));
      wrap.querySelectorAll('[data-go]').forEach(function (b) { b.setAttribute('aria-current', +b.dataset.go === cur ? 'true' : 'false'); });
    }
    function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); setCur(i); }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { setCur(Math.round(track.scrollLeft / track.clientWidth)); });
    }, { passive: true });
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-go]'); if (b) go(+b.dataset.go);
      if (e.target.closest('.gal-nav.prev')) go(cur - 1);
      if (e.target.closest('.gal-nav.next')) go(cur + 1);
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    });
    setCur(0);
  }

  /* ---------- Köpbox (produktsida) ----------
     Kunden väljer leveransintervall: var 30:e dag (1 förpackning) eller var 3:e månad (3 förpackningar, Viskan: 91 dagar).
     Båda läggs som månad 1-varianten utan selling plan (_Intervall 30/90 dagar). Tillval läggs med
     samma intervall och antal 1. Rabattsatsen bestäms av totalt antal förpackningar i leveransen
     (tier: 2 → −10 %, 3 eller fler → −15 %), samma som Shopifys automatiska rabatt på månad 1-produkterna. */
  function initBuybox(box) {
    var data = readData(box);
    if (!data || !data.main) return;
    var main = data.main;
    var others = {};
    (data.others || []).forEach(function (o) { others[o.h] = o; });
    var q = function (s) { return box.querySelector(s); };
    var addInputs = box.querySelectorAll('.chips input');
    var ivalInputs = box.querySelectorAll('.ivals input');
    var sticky = document.querySelector('[data-mv5-sticky]');

    function state() {
      var checked = box.querySelector('.ivals input:checked');
      var every = checked && checked.value === '3' ? 3 : 1;
      var adds = every === 3 ? [] : [].slice.call(addInputs).filter(function (i) { return i.checked && others[i.value] && others[i.value].sub; }).map(function (i) { return others[i.value]; });
      // Förpackningar i leveransen: intro = månad 1-priset (betalas i kassan), price = fortsättningspris.
      var pick = function (p) { return { p: p, intro: p.intro, price: p.price }; };
      var list = [];
      for (var k = 0; k < every; k++) list.push(pick(main));
      list = list.concat(adds.map(pick));
      return { every: every, adds: adds, list: list, first: firstPrice(list), rec: monthly(list), full: sum(list, 'price') };
    }
    // Inga tillval vid 3-månadersleverans (Viskans 90d-mall gäller en produkt): dölj blocket, avmarkera och visa hänvisningen.
    var addBox = q('[data-addons]'), addQ = q('[data-addons-q]');
    function syncAddons() {
      var c = box.querySelector('.ivals input:checked'), quarter = !!(c && c.value === '3');
      if (quarter) addInputs.forEach(function (i) { i.checked = false; });
      addInputs.forEach(function (i) { i.disabled = quarter; });
      if (addBox) addBox.hidden = quarter;
      if (addQ) addQ.hidden = !quarter;
    }
    function render(animate) {
      syncAddons();
      var s = state(), c = s.list.length;
      var pf = q('[data-p-first]');
      if (pf) { pf.textContent = kr(s.first); if (animate) pop(pf); }
      var pml = q('[data-p-month-l]'); if (pml) pml.textContent = s.every === 3 ? 'Därefter var 3:e månad' : 'Därefter per leverans';
      var pm = q('[data-p-month]'); if (pm) pm.textContent = kr(s.rec);
      renderSave(box, s.full, s.rec, c, s.every === 3 ? 'var 3:e månad' : 'varje leverans', animate);
      box.querySelectorAll('[data-mv5-terms]').forEach(function (el) {
        var f = el.querySelector('[data-t-first]'), m = el.querySelector('[data-t-month]'), per = el.querySelector('[data-t-per]'), cy = el.querySelector('[data-t-cycle]');
        if (f) f.textContent = kr(s.first);
        if (m) m.textContent = kr(s.rec);
        if (per) per.textContent = s.every === 3 ? ' per leverans (' + c + ' förpackningar)' : ' per leverans';
        if (cy) cy.textContent = s.every === 3 ? 'var 3:e månad' : 'var 30:e dag';
      });
      var cta = q('[data-mv5-start]'); if (cta) cta.textContent = 'Starta för ' + kr(s.first);
      if (sticky) {
        var sp = sticky.querySelector('[data-s-price]'), ss = sticky.querySelector('[data-s-sub]');
        if (sp) sp.textContent = 'Starta för ' + kr(s.first);
        if (ss) ss.textContent = 'Därefter ' + kr(s.rec) + (s.every === 3 ? ' var 3:e månad' : ' per leverans') + ' mot faktura · fri frakt';
      }
    }
    ivalInputs.forEach(function (i) { i.addEventListener('change', function () { render(true); }); });
    addInputs.forEach(function (i) { i.addEventListener('change', function () { render(true); }); });

    var start = q('[data-mv5-start]');
    if (start) start.addEventListener('click', function () {
      var s = state();
      if (!main.sub || !main.start) {
        showErr(start, 'Abonnemanget går inte att starta på webben just nu. Ring oss på ' + CFG.phone + '.');
        return;
      }
      var entries = [{ p: main, n: s.every }].concat(s.adds.map(function (a) { return { p: a, n: 1 }; }));
      checkout(subItems(entries, s.every === 3 ? 90 : 30), start);
    });
    var once = q('[data-mv5-once]');
    if (once) once.addEventListener('click', function () { checkout([{ id: main.variant, quantity: 1 }], once); });
    render(false);
  }

  /* ---------- Paketbyggare ---------- */
  function initBuilder(root) {
    var data = readData(root);
    if (!data || !data.products) return;
    var P = {}, order = [];
    data.products.forEach(function (p) { P[p.h] = p; order.push(p.h); });
    var qty = {};
    order.forEach(function (h) { qty[h] = 0; });
    var pre = new URLSearchParams(location.search).get('p');
    if (pre && P[pre] && P[pre].avail) qty[pre] = 1;
    var $ = function (s) { return root.querySelector(s); };
    var summary = $('[data-summary]'), backdrop = $('[data-backdrop]'), toggleBtn = $('[data-sum-toggle]');
    var termsEl = $('[data-terms-empty]');
    var emptyTerms = termsEl ? termsEl.innerHTML : '';
    var email = data.email || 'info@medvital.se';
    var head = $('[data-sum-head]'), go = $('[data-bb-go]'), shortEl = $('[data-bb-short]'), htm = $('[data-ht-m]');
    var mq = window.matchMedia ? window.matchMedia('(max-width: 959px)') : { matches: window.innerWidth < 960 };
    // Bottenbarens höjd → --bb-h (sheetens hopfällda läge och sidans padding-bottom så att baren inte täcker footern).
    function setH() {
      if (!head) return;
      var h = mq.matches && summary.classList.contains('has') ? head.offsetHeight : 0;
      summary.style.setProperty('--bb-h', h + 'px');
      document.documentElement.style.setProperty('--bb-h', h + 'px');
    }

    function list() { var l = []; order.forEach(function (h) { for (var i = 0; i < qty[h]; i++) l.push(P[h]); }); return l; }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function render(animate) {
      var l = list(), n = l.length;
      order.forEach(function (h) {
        var card = root.querySelector('.pick[data-k="' + h + '"]');
        if (!card) return;
        var add = card.querySelector('[data-add]'), st = card.querySelector('.stepper');
        card.classList.toggle('on', qty[h] > 0);
        if (add) { add.hidden = qty[h] > 0; add.disabled = n >= MAX; add.textContent = n >= MAX ? 'Max 3 valda' : 'Lägg till'; }
        if (st) { st.hidden = qty[h] === 0; st.querySelector('output').value = qty[h]; st.querySelector('output').textContent = qty[h]; st.querySelector('[data-inc]').disabled = n >= MAX; }
      });
      root.querySelectorAll('.bb-rung').forEach(function (r) { var rn = +r.dataset.n; r.classList.toggle('lit', n >= rn); r.classList.toggle('now', n === rn); });
      $('[data-counter]').innerHTML = '<b>' + n + ' av ' + MAX + '</b> valda' + (n === 1 ? ' – lägg till en till för paketpris' : '');
      var first = n ? firstPrice(l) : 0, month = n ? monthly(l) : 0, full = sum(l, 'price');
      var chosen = order.filter(function (h) { return qty[h]; });
      $('[data-stack]').innerHTML = n ? chosen.map(function (h) { return '<span style="--t:' + P[h].tint + '">' + (P[h].img ? '<img src="' + P[h].img + '" width="26" height="26" alt="" loading="lazy">' : '') + '</span>'; }).join('') : '<span class="empty">+</span>';
      $('[data-ht]').innerHTML = n ? '<b>Första leveransen ' + kr(first) + '</b>' + n + ' ' + (n === 1 ? 'produkt' : 'produkter') + ' · därefter ' + kr(month) + ' per leverans' : '<b>Inget valt än</b>Välj minst 2 produkter';
      $('[data-sel]').innerHTML = chosen.map(function (h) {
        var p = P[h];
        return '<li><span class="im" style="--t:' + p.tint + '">' + (p.img ? '<img src="' + p.img + '" width="34" height="34" alt="" loading="lazy">' : '') + '</span><span class="nm">' + qty[h] + ' × ' + esc(p.name) + '<small>' + esc(p.cat || '') + '</small></span><span class="pr">' + kr(p.price * qty[h]) + '/mån ord.</span></li>';
      }).join('') + (n < 2 ? '<li class="hint">' + (n === 0 ? 'Välj produkter ovan.' : 'Lägg till minst en produkt till för paketpris.') + '</li>' : '');
      var pf = $('[data-p-first]'); pf.textContent = n ? kr(first) : '–'; if (animate) pop(pf);
      $('[data-p-month]').textContent = n ? kr(month) : '–';
      $('[data-p-per]').textContent = n ? 'Motsvarar ' + kr(month / n) + ' per produkt och månad · ca ' + perDay(month, n) + ' kr per dag' : '';
      renderSave(root, full, month, n, 'varje leverans', animate);
      if (termsEl) termsEl.innerHTML = n
        ? '<b>Första leveransen ' + kr(first) + ' betalas i kassan. Därefter ' + kr(month) + ' per leverans mot faktura i paketet</b> – 14 dagars betaltid, ingen avgift. Ny leverans var 30:e dag. Använd så länge du vill – pausa eller avsluta via telefon ' + esc(root.dataset.phone || '031-78 131 55') + ' eller ' + esc(email) + ' senast 14 dagar före nästa leverans. 14 dagars ångerrätt. Fri frakt.'
        : emptyTerms;
      var cta = $('[data-bb-cta]');
      cta.setAttribute('aria-disabled', n < 2 ? 'true' : 'false');
      cta.textContent = n < 2 ? 'Välj minst 2 produkter' : (mq.matches ? 'Bekräfta och gå till kassan' : 'Starta paketet för ' + kr(first));
      // Mobilens bottenbar
      summary.classList.toggle('has', n > 0);
      document.body.classList.toggle('bb-on', n > 0);
      if (!n && summary.classList.contains('open')) toggle(false);
      var t = tier(n), saveM = n > 1 && t > 0 && full > month ? full - month : 0;
      if (htm) htm.innerHTML = n
        ? '<b>' + n + ' ' + (n === 1 ? 'produkt' : 'produkter') + ' · ' + kr(first) + '</b><span>första leveransen' + (saveM ? ' <i class="bb-pill">Spara ' + kr(saveM) + '/mån</i>' : '') + '</span>'
        : '';
      if (go) {
        go.setAttribute('aria-disabled', n < 2 ? 'true' : 'false');
        go.textContent = n < 2 ? 'Välj en till' : 'Till kassan';
      }
      if (shortEl) shortEl.innerHTML = n < 2
        ? 'Lägg till en produkt till för paketpris'
        : 'Därefter ' + kr(month) + ' var 30:e dag mot faktura · ingen bindningstid · <button type="button" data-bb-terms>Villkor ↑</button>';
      setH();
    }
    function toggle(open) {
      var o = open === undefined ? !summary.classList.contains('open') : open;
      summary.classList.toggle('open', o);
      backdrop.classList.toggle('show', o);
      toggleBtn.setAttribute('aria-expanded', String(o));
      if (!o) summary.scrollTop = 0;
    }
    // Fäll upp detaljerna och visa villkoren + bekräfta-knappen (köpet görs bara därifrån på mobil).
    function showTerms() {
      toggle(true);
      var tEl = termsEl || $('[data-bb-cta]');
      var ctaEl = $('[data-bb-cta]');
      requestAnimationFrame(function () {
        var bottom = ctaEl.offsetTop + ctaEl.offsetHeight + 16;
        summary.scrollTop = Math.max(0, Math.min(tEl.offsetTop - head.offsetHeight - 12, bottom - summary.clientHeight));
        pop(tEl);
        try { ctaEl.focus({ preventScroll: true }); } catch (e) {}
      });
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-add],[data-inc],[data-dec]');
      if (b && !b.disabled) {
        var h = b.dataset.add || b.dataset.inc || b.dataset.dec;
        if (!P[h]) return;
        if (b.dataset.dec) qty[h] = Math.max(0, qty[h] - 1);
        else if (list().length < MAX) qty[h] += 1;
        render(true);
      }
    });
    toggleBtn.addEventListener('click', function () { if (mq.matches) toggle(); });
    if (go) go.addEventListener('click', function () { if (list().length >= 2) showTerms(); });
    if (shortEl) shortEl.addEventListener('click', function (e) { if (e.target.closest('[data-bb-terms]')) showTerms(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && summary.classList.contains('open')) toggle(false); });
    if (mq.addEventListener) mq.addEventListener('change', function () { if (!mq.matches) toggle(false); render(false); });
    window.addEventListener('resize', setH);
    backdrop.addEventListener('click', function () { toggle(false); });
    var cta = $('[data-bb-cta]');
    cta.addEventListener('click', function () {
      var l = list();
      if (l.length < 2) { $('[data-counter]').scrollIntoView({ behavior: 'smooth', block: 'center' }); toggle(false); return; }
      var items = subItems(order.filter(function (h) { return qty[h]; }).map(function (h) { return { p: P[h], n: qty[h] }; }), 30);
      if (!items.length) { showErr(cta, 'Abonnemanget går inte att starta på webben just nu. Ring oss på ' + CFG.phone + '.'); return; }
      checkout(items, cta);
    });
    render(false);
  }

  /* ---------- Roterande ord + bild-crossfade (hero) ----------
     Pausar vid prefers-reduced-motion (första ordet/bilden står still), när fliken är dold
     och när elementet inte syns. Ändrar bara klasser – ingen layout påverkas. */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function cycle(el, items, every, step) {
    if (items.length < 2 || reduceMotion || el.dataset.mv5Cycling) return;
    el.dataset.mv5Cycling = '1';
    var i = 0, timer = null, visible = true;
    function start() { if (timer || !visible || document.hidden) return; timer = setInterval(function () { var next = (i + 1) % items.length; if (step(items[i], items[next])) i = next; }, every); }
    function stop() { clearInterval(timer); timer = null; }
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (ens) { visible = ens[0].isIntersecting; if (visible) start(); else stop(); }).observe(el);
    } else start();
  }
  function initRot(el) {
    var ws = el.querySelectorAll('.rot-w');
    cycle(el, ws, +el.dataset.every || 2600, function (cur, next) {
      cur.classList.remove('is-on'); cur.classList.add('is-out');
      next.classList.remove('is-out'); next.classList.add('is-on');
      setTimeout(function () { cur.classList.remove('is-out'); }, 600);
      return true;
    });
  }
  function initFade(el) {
    var imgs = el.querySelectorAll('img');
    cycle(el, imgs, +el.dataset.every || 4500, function (cur, next) {
      if (!next.complete || !next.naturalWidth) return false; // vänta tills nästa bild laddats
      cur.classList.remove('is-on'); next.classList.add('is-on');
      return true;
    });
  }

  /* ---------- Ingredienshjul ----------
     Listan är dubblerad (data-n = ord per kopia). Varje steg flyttar spåret en rad med transform; när
     indexet passerat en hel kopia hoppar vi tillbaka utan animation (identiskt innehåll → osynligt).
     Paus vid hover/fokus, dold flik och utanför viewport. Reduced motion: statisk lista med mittordet markerat. */
  function initWheel(el) {
    var track = el.querySelector('.wheel-track');
    if (!track || el.dataset.mv5Wheel) return;
    el.dataset.mv5Wheel = '1';
    var items = [].slice.call(track.children);
    var n = +el.dataset.n || items.length;
    if (!n) return;
    var every = Math.max(1200, +el.dataset.every || 2000);
    var half = 2, idx = 2, timer = null, visible = true, hover = false;
    function measure() {
      var cs = getComputedStyle(el);
      var rows = parseInt(cs.getPropertyValue('--wh-rows'), 10) || 3;
      half = Math.floor(rows / 2);
      return parseFloat(cs.getPropertyValue('--wh-row')) || 54;
    }
    function paint(anim) {
      var rh = measure();
      if (!anim) track.classList.add('no-anim');
      track.style.transform = 'translateY(' + (-(idx - half) * rh) + 'px)';
      items.forEach(function (it, i) { it.classList.toggle('is-on', i === idx); });
      if (!anim) { void track.offsetWidth; track.classList.remove('no-anim'); }
    }
    function step() {
      idx += 1;
      paint(true);
      if (idx >= n + half) setTimeout(function () { idx -= n; paint(false); }, 600);
    }
    function start() { if (timer || !visible || hover || document.hidden || reduceMotion) return; timer = setInterval(step, every); }
    function stop() { clearInterval(timer); timer = null; }
    idx = half = Math.floor((parseInt(getComputedStyle(el).getPropertyValue('--wh-rows'), 10) || 3) / 2);
    paint(false);
    if (reduceMotion) return;
    var sec = el.closest('section') || el;
    sec.addEventListener('focusin', function () { hover = true; stop(); });
    sec.addEventListener('focusout', function () { hover = false; start(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { paint(false); }, 150); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (ens) { visible = ens[0].isIntersecting; if (visible) start(); else stop(); }).observe(el);
    } else start();
  }

  function init() {
    document.querySelectorAll('[data-mv5-rot]').forEach(initRot);
    document.querySelectorAll('[data-mv5-fade]').forEach(initFade);
    document.querySelectorAll('[data-mv5-wheel]').forEach(initWheel);
    // Scroll-in
    var rev = document.querySelectorAll('.reveal:not(.in)');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ens) {
        ens.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      rev.forEach(function (el) { io.observe(el); });
    } else rev.forEach(function (el) { el.classList.add('in'); });

    // Fast köprad (mobil, ägarbeslut 2026-10-12): synlig direkt vid sidladdning, dold bara medan köpboxens egna
    // prisområde/köpknapp ([data-sticky-hide]) syns i viewporten och medan Shopifys cookie-banner är öppen.
    var sticky = document.querySelector('[data-mv5-sticky]');
    if (sticky) {
      var zones = [].slice.call(document.querySelectorAll('[data-sticky-hide]'));
      if (!zones.length) zones = [].slice.call(document.querySelectorAll('[data-sticky-target]'));
      var seen = zones.map(function () { return false; });
      var cookieOpen = function () {
        var b = document.getElementById('shopify-pc__banner');
        if (!b) return false;
        var cs = getComputedStyle(b), r = b.getBoundingClientRect();
        return cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0 && r.top < window.innerHeight;
      };
      var updSticky = function () {
        var hide = seen.some(Boolean) || cookieOpen();
        sticky.classList.toggle('show', !hide);
      };
      if ('IntersectionObserver' in window && zones.length) {
        var sio = new IntersectionObserver(function (ens) {
          ens.forEach(function (en) { seen[zones.indexOf(en.target)] = en.isIntersecting; });
          updSticky();
        });
        zones.forEach(function (z) { sio.observe(z); });
      } else updSticky();
      // Cookie-bannern injiceras asynkront och stängs utan händelse vi kan lita på: kontrollera med jämna mellanrum
      // de första 20 sekunderna och därefter så länge bannern är öppen.
      var t0 = Date.now();
      var cTimer = setInterval(function () {
        var open = cookieOpen();
        updSticky();
        if (!open && Date.now() - t0 > 20000) clearInterval(cTimer);
      }, 400);
      document.addEventListener('visitorConsentCollected', function () { setTimeout(updSticky, 50); });
    }

    document.querySelectorAll('[data-mv5-gal]').forEach(initGallery);
    document.querySelectorAll('[data-mv5-buybox]').forEach(initBuybox);
    document.querySelectorAll('[data-mv5-builder]').forEach(initBuilder);
    document.querySelectorAll('.ticker').forEach(initTicker);
    document.querySelectorAll('[data-mv5-mega]').forEach(initMega);
    document.querySelectorAll('[data-mv5-burger]').forEach(initBurger);
  }
  // Produktmeny i headern: öppnas vid hover och tangentbordsfokus, Esc stänger och lämnar fokus på länken.
  // På pekskärm (bred surfplatta) öppnar första trycket menyn, andra trycket följer länken.
  function initMega(item) {
    if (item.dataset.ready) return; item.dataset.ready = '1';
    var top = item.querySelector('.nav-top');
    var t = 0, suppressed = false;
    function set(open) {
      clearTimeout(t);
      item.classList.toggle('open', open);
      top.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    item.addEventListener('mouseenter', function () { if (!suppressed) { clearTimeout(t); t = setTimeout(function () { set(true); }, 60); } });
    item.addEventListener('mouseleave', function () { suppressed = false; clearTimeout(t); t = setTimeout(function () { if (!item.contains(document.activeElement)) set(false); }, 140); });
    item.addEventListener('focusin', function () { if (!suppressed) set(true); });
    item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) { suppressed = false; set(false); } });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && item.classList.contains('open')) { e.preventDefault(); suppressed = true; set(false); top.focus(); }
    });
    top.addEventListener('keydown', function (e) {
      if ((e.key === 'ArrowDown' || e.key === ' ') && !item.classList.contains('open')) { e.preventDefault(); suppressed = false; set(true); }
      if (e.key === 'ArrowDown') { var f = item.querySelector('.mega a'); if (f) { e.preventDefault(); set(true); f.focus(); } }
    });
    top.addEventListener('pointerup', function (e) { item._touch = e.pointerType === 'touch'; });
    top.addEventListener('click', function (e) {
      if (item._touch && !item.classList.contains('open')) { e.preventDefault(); set(true); }
    });
    document.addEventListener('click', function (e) { if (!item.contains(e.target)) set(false); });
  }
  // Menyknapp (under 960 px): öppnar panelen med samma länkar. Esc och klick utanför stänger, fokus tillbaka till knappen.
  function initBurger(btn) {
    if (btn.dataset.ready) return; btn.dataset.ready = '1';
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    function set(open, focusBtn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
      document.documentElement.classList.toggle('mnav-open', open);
      if (open) { var f = panel.querySelector('a'); if (f) f.focus({ preventScroll: true }); }
      else if (focusBtn) btn.focus();
    }
    btn.addEventListener('click', function () { set(panel.hidden); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) set(false, true); });
    document.addEventListener('click', function (e) { if (!panel.hidden && !panel.contains(e.target) && !btn.contains(e.target)) set(false); });
    window.addEventListener('resize', function () { if (window.innerWidth >= 960 && !panel.hidden) set(false); });
  }
  // Rullande bandet: inställningen "sekunder per varv" gällde med 34 px padding. Med dubbla mellanrummet (68 px)
  // blir spåret längre – skala varvtiden så att hastigheten i px/s blir exakt densamma som förut.
  function initTicker(t) {
    var track = t.querySelector('.ticker-track');
    if (!track) return;
    var spans = track.children.length, w = track.scrollWidth;
    var base = parseFloat(getComputedStyle(t).getPropertyValue('--speed')) || 70;
    var old = w - spans * 68; // samma text med 2 × 34 px per ord
    if (old > 0 && w > 0) track.style.setProperty('--speed-px', (base * w / old).toFixed(2) + 's');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Temaeditorn: initiera om när en sektion laddas om
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    t.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
    t.querySelectorAll('[data-mv5-rot]').forEach(initRot);
    t.querySelectorAll('[data-mv5-fade]').forEach(initFade);
    t.querySelectorAll('[data-mv5-wheel]').forEach(initWheel);
    t.querySelectorAll('[data-mv5-gal]').forEach(initGallery);
    t.querySelectorAll('[data-mv5-buybox]').forEach(initBuybox);
    t.querySelectorAll('[data-mv5-builder]').forEach(initBuilder);
    t.querySelectorAll('.ticker').forEach(initTicker);
    t.querySelectorAll('[data-mv5-mega]').forEach(initMega);
    t.querySelectorAll('[data-mv5-burger]').forEach(initBurger);
  });
})();
